export default __webpack_public_path__ + "static/media/manage.144ea7ea.svg";